/* Prekes korteles nuotraukos paspaudimas karuseleje (Kasakai, 2026-09-01).

   Tema uzdraudzia nuotraukos nuoroda visoje karuseleje, kai ijungtas vilkimas
   (card-product.liquid: onclick -> return false), nes po vilkimo pele vis tiek
   sugeneruoja click ir naršykle nuneša i atsitiktine preke. Del to darbastalyje
   paspaudus ant nuotraukos nevykdavo NIEKO.

   Cia ismatuojama, ar tarp pointerdown ir click pele realiai pajudejo. Jei ne -
   tai paprastas paspaudimas ir nuoroda leidziama. */
(function () {
  var THRESHOLD = 8; // px - tiek leidziama sudrebeti rankai
  var pressed = false;
  var moved = false;
  var startX = 0;
  var startY = 0;

  document.addEventListener('pointerdown', function (event) {
    pressed = true;
    moved = false;
    startX = event.clientX;
    startY = event.clientY;
  }, true);

  document.addEventListener('pointermove', function (event) {
    if (!pressed || moved) return;
    if (Math.abs(event.clientX - startX) > THRESHOLD || Math.abs(event.clientY - startY) > THRESHOLD) {
      moved = true;
    }
  }, true);

  document.addEventListener('pointerup', function () {
    pressed = false;
  }, true);

  document.addEventListener('pointercancel', function () {
    pressed = false;
    moved = true;
  }, true);

  window.kasakaiCardDragged = function () {
    return moved;
  };
})();
